import * as angular from "angular";

angular
  .module('bringoz.admin.agents')
  .constant('Agents_PN', {
    database: 'agents',
    isBranchEntity: true
  });
